module.exports = __webpack_public_path__ + "media/navigation/icon-heart-9d362652.svg";